import { render, staticRenderFns } from "./BookerTestRolePlay.vue?vue&type=template&id=622cb44f"
import script from "./BookerTestRolePlay.vue?vue&type=script&lang=js"
export * from "./BookerTestRolePlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports